'use strict';


function translation(langs)
{
    $('.translation').each(function(){
        if ($(this).hasClass('translation-placeholder'))
        {
            if (langs[$(this).attr('placeholder')])
            {
                $(this).attr('placeholder', langs[$(this).attr('placeholder')]);
            }
        }
        else if ($(this).text())
        {
            if (langs[$(this).text()])
            {
                $(this).text(langs[$(this).text()]);
            }
        }
        else
        {
            if (langs[$(this).val()])
            {
                $(this).val(langs[$(this).val()]);
            }

        }
        $(this).removeClass('translation');
    });
}

(function ($) {

    $(function(){

    // Steps form

        var contactStep = $('ul.step-contacts');
        var uploadStep = $('ul.step-upload');
        var priceStep = $('ul.step-price');

        var contactStepNumb = $('.step-count-item.first');
        var uploadStepNumb = $('.step-count-item.second');
        var priceStepNumb = $('.step-count-item.last');

        var nextButton = $('.nav > .next');
        var prevButton = $('.nav > .prev');
        var submitButton = $('button.order-submit');

        var infoBlock = $('.step-form > .info');

        var currentFormStep = 'first';

        function firstStep() {

            contactStep.show();
            uploadStep.hide();
            priceStep.hide();

            nextButton.css('display', 'inline-block');
            prevButton.hide();
            prevButton.removeClass('last-step');
            submitButton.hide();
            infoBlock.show();

            contactStepNumb.addClass('active');
            uploadStepNumb.removeClass('active');
            priceStepNumb.removeClass('active');


            currentFormStep = 'first';
        }

        function secondStep() {

            contactStep.hide();
            uploadStep.show();
            priceStep.hide();

            nextButton.css('display', 'inline-block');
            prevButton.removeClass('last-step');

            if ($('body').attr('data-logged-in') === '1') {
                contactStepNumb.hide();
                uploadStepNumb.text('1');
                priceStepNumb.text('2');
                prevButton.hide();
            }

            else {
                prevButton.css('display', 'inline-block');
            }

            submitButton.hide();
            infoBlock.hide();

            contactStepNumb.removeClass('active');
            uploadStepNumb.addClass('active');
            priceStepNumb.removeClass('active');

            currentFormStep = 'second';
        }

        function lastStep() {

            contactStepNumb.removeClass('active');
            uploadStepNumb.removeClass('active');
            priceStepNumb.addClass('active');

            contactStep.hide();
            uploadStep.hide();
            priceStep.show();

            infoBlock.hide();

            nextButton.hide();
            prevButton.css('display', 'inline-block');
            prevButton.addClass('last-step');
            submitButton.css('display', 'inline-block');

            currentFormStep = 'last';
        }
        

        $(nextButton).on( 'click', function() { 
            if ( currentFormStep == 'first' ) {
                secondStep();                   
            }
            else {                      
                lastStep();
            }
        });

        $(prevButton).on( 'click', function() {
            if ( currentFormStep == 'last' ) {
                    secondStep();                   
                }
                else {                      
                    firstStep();
                }
        });

        // $(contactStepNumb).on('click', function() {
        //     firstStep();
        // })

        // $(uploadStepNumb).on('click', function() {
        //     secondStep();
        // })

        // $(priceStepNumb).on('click', function() {
        //     lastStep();
        // })


        if ($('body').attr('data-logged-in') === '1') {
            var currentFormStep = 'second';
            secondStep();
        }
        else {
            firstStep();
        }
        
        api.checkLogin(); 

    // EVENTS 


        $(window).on('loggedIn', function (e, mail) {
            $('.signin-button').hide();
            $('.orders-button').show();
            $('.signout-button').show();
            $('.orderform-mail input')
                .val(mail)
                .prop('disabled', true);
        });

        $(window).on('loggedOut', function () {
            $('.signin-button').show();
            $('.orders-button').hide();
            $('.signout-button').hide();
            $('.orderform-mail input')
                .val('')
                .prop('disabled', false);
        });

        $('.orderform, .orderform-ziggy').on('submit', function (e) {
            e.preventDefault();
            if (!$(this).valid()) {
                firstStep();
                return;
            }
            orderSubmit.call(this);
        });


        $('[data-remodal-id*="edit-order-ziggy"]')
            .one('open', handleEditOrderOpen)
            .on('close', function () {
                $('.orderform', $(this)).each(function () {
                    this.reset();
                });
            });

        $('[data-remodal-id="restore-ziggy"] .request-restore-button')
            .on('click', function (e) {
                e.preventDefault();
                $('.request-restore-button').loading('start');
                api.authRestore($('[data-remodal-id="restore-ziggy"]'), function (err, data) {
                    if (err) {
                        return $('.request-restore-button').loading('error');
                    }
                });
                    api.createTempOrder($('.orderform-ziggy'),  function (e) {
                    $('.request-restore-button').loading('finish');
                    dialogs.restoreDialogZiggy.close();
                    $.remodal.lookup[ $('.remodal[data-remodal-id="restore-pass-form"]').data('remodal') ].open();
                });
            });


        $('.welcome-confirm-button-ziggy').on('click', function (e) {
            e.preventDefault();
            var $mailField = $('[data-remodal-id="welcome-ziggy"] .email-field');
            if ($mailField.data('submittedMail')
                && $mailField.val() !== $mailField.data('submittedMail')) {
                $('.welcome-confirm-button-ziggy').loading('start');
                api.authUpdate($mailField.val(), function (err) {
                    if (err) {
                        return $('.welcome-confirm-button-ziggy').loading('error');
                    }
                    $('.welcome-confirm-button-ziggy').loading('finish');
                    window.location.href = $('input[type="hidden"][name="language"]').val() + '/orders';
                });
            }
            else {
                window.location.href = $('input[type="hidden"][name="language"]').val() + '/orders';
            }
        });

        $('.social-links a').on('click',function(){
            socialPopup($(this).attr('data-url'), $(this).attr('data-type'));
        });

        /* For some reason being called every time you hit 'esc' */
        // $('[data-remodal-id="welcome"]').on('close', function() {
        // 	window.location.href = '/orders';
        // });

        $('[data-remodal-id="login-ziggy"]').on('submit', function (e) {
            e.preventDefault();
            if (!$(this).valid()) {
                return;
            }
            $('.signin-button').loading('start');
            api.authLogin($('[data-remodal-id="login-ziggy"]'), function (err, logged) {
                if (err) {
                    $('.signin-button').loading('error');
                    if (~err.indexOf('email: Invalid email or password')) {
                        $('[data-remodal-id="login-ziggy"]').validate().showErrors({
                            email: '',
                            password: 'Wrong email or password'
                        });
                    }
                    return;
                }
                if (logged.email)
                {
                    $('#email').val(logged.email);
                    $('#email').attr('disabled','disabled');
                }
                $('#tel').val(logged.phone);
                $('.signin-button').loading('finish');
                $('#login-pass').val('');
                $(window).trigger('loggedIn', logged.email);
                dialogs.loginDialogZiggy.close();
                if ($('.orderform').data('awaitingForLogin')) {
                    $('.orderform').trigger('submit');
                }
                if ($('.orderform-ziggy').data('awaitingForLogin')) {
                    $('.orderform-ziggy').trigger('submit');
                }
            });
        });

        $('[data-remodal-id="login-ziggy"] .sign-up').on('click', function(){
            $('.remodal-active .remodal-close').click();
            window.location.hash = 'lets-start';
        });

        $('[data-remodal-id="login-ziggy"]').on('close', function (e) {
            $('.order-submit', $('.orderform-ziggy')).loading('finish');
        });

        $('.signout-button').on('click', function (e) {
            e.preventDefault();
            $('.signout-button').loading('start');
            api.authLogout(true, function (err) {
                if (err) {
                    return $('.signout-button').loading('error');
                }
                $(window).trigger('loggedOut');
                window.location.reload();
            });
        });

        setTimeout(function(){
            if ($('[data-remodal-id="exit-form"]').attr('data-skip'))
            {
                var dontLeaveModal = false;
            }
            else
            {
                var dontLeaveModal = true;
            }
            var tempYpos = false;
            if (dontLeaveModal)
            {
                $(window).mousemove(function(e){
                if(e.clientY < 5 && tempYpos && dontLeaveModal && !$('.remodal-active').length)
                {
                    if (e.clientY < tempYpos)
                    {
                        $.remodal.lookup[ $('.remodal[data-remodal-id="exit-form"]').data('remodal') ].open();
                        dontLeaveModal = false;
                        document.cookie="leaving_page_interview=1; expires=" + new Date(new Date().getTime() + 86400 * 30 * 1000);
                    }
                }
                tempYpos = e.clientY;
                });
            }
        }, 10000);
    });


    /* Floating footer */
    $(window).on('resize', $.debounce(300, floatingFooter));

    $(floatingFooter);
    function floatingFooter() {
        var $footer = $('.footer-content');
        if (!$footer.length) {
            return;
        }
        var footerBottom = $footer.offset().top + $footer.outerHeight();
        var winHeight = $(window).innerHeight();

        if (!$footer.data('marker')) {
            $footer.data('marker', $('<div style="clear:both;"></div>').insertBefore($footer));
        }

        var contentEnd = $footer.data('marker').offset().top;

        if ($footer.data('floating')) {
            if (contentEnd + $footer.outerHeight() > winHeight) {
                $footer.css({
                    position: '',
                    bottom: ''
                }).data('floating', false);
            }
        } else {
            if (footerBottom < winHeight) {
                $footer.css({
                    position: 'fixed',
                    bottom: '0'
                }).data('floating', true);
            }
        }
    }

    // Adding files already stored on server
    Dropzone.prototype.addFromServer = function (file) {
        var dz = this;
        file.type = 'video';
        file.status = Dropzone.ADDED;
        file.upload = {
            progress: 0,
            total: file.size,
            bytesSent: 0
        };
        dz.files.push(file);
        dz.emit('addedfile', file);
        // this._enqueueThumbnail(file);
        return dz.accept(file, function (error) {
            if (error) {
                file.accepted = false;
                dz._errorProcessing([file], error);
            }
            file.accepted = true;
            $(file.previewElement)
                .data('file_id', file.file_id)
                .addClass('dz-success')
                .find('.dz-upload').css({width: '100%'});
            return dz._updateMaxFilesReachedClass();
        });
    };


    function handleEditOrderOpen() {
        var $this = $(this);
        var $thisDialog = $.remodal.lookup[$this.data('remodal')];
        var $thisForm = $(this).find('.orderform');
        api.getOrderInfo($this.data('orderId'), function (err, order) {
            if (err) {
                $thisDialog.close()
                return $thisForm.loading('error');
            }
            $thisForm.loading('finish');
            var orderData = order;
            if (!orderData) {
                return console.error('No order info');
            }

            /* Populate form with json data */

            $('[name="description"]', $thisForm).text(orderData.description);
            $('.duration', $thisForm)
                .val(orderData.minutes)
                .trigger('slide', orderData.minutes);

            var dropzone = Dropzone.forElement($thisForm[0]);
            $.each(orderData.files, function (i, file) {

                var fileExists = false;

                dropzone.files.forEach(function (v, k) {
                    if (file.file_id == v.file_id) {
                        fileExists = true;
                    }
                });

                if (fileExists) {
                    return;
                }

                dropzone.addFromServer(file);

            });
        });
    }

    function socialPopup(url, type){

        var popup = window.open(url, type, 'width=800,height=600');
        var intervalPopup = window.setInterval(function() {
            try {
                if (popup == null || popup.closed) {
                    window.clearInterval(intervalPopup);
                    api.checkLogin();
                }
            }
            catch (e) {
            }
        }, 1000);
        return popup;

    }

    function orderSubmit() {
        var $form = $(this);

        $('.order-submit', $form).loading('start');

        if ($form.parent('.edit-dialog').length) {

            /* Editing existing order */

            api.orderUpdate($form, function (err) {
                if (err) {
                    return $('.order-submit', $form).loading('error');
                }
                $('.order-submit', $form).loading('finish');
                $.remodal.lookup[$form.parent('.edit-dialog').data('remodal')].close();
                window.location.reload();
            });

        } else if ($('body').data('loggedIn')) {

            /* User is authorized */

            console.info('Is authorized user');
            api.orderCreate($form, function (err) {
                if (err) {
                    return $('.order-submit', $form).loading('error');
                }
                $('.order-submit', $form).loading('finish');
                window.location.href = $('input[type="hidden"][name="language"]').val() + '/orders';
            });

        } else {

            api.checkIsEmailExists($('#email', $form).val(), function (err, checked) {
                if (err) {
                    return $('.order-submit', $form).loading('error');
                }
                if (checked.exist) {

                    $('#login-email-ziggy').val($('#email').val());
                    dialogs.loginDialogZiggy.open();
                    $form
                        .data('awaitingForLogin', true)
                        .one('change', function () {
                            $form.data('awaitingForLogin', false);
                            $('.order-submit', $form).loading('finish');
                        });

                } else {

                    /* New user */

                    api.authCreate($('#email', $form).val(), function (err, created) {
                        if (err) {
                            return $('.order-submit', $form).loading('error');
                        }
                        var email = created.email;
                        $('[data-remodal-id="welcome-ziggy"] .email-field')
                            .data('submittedMail', email)
                            .val(email);
                        api.orderCreate($form, function (err) {
                            if (err) {
                                return $('.order-submit', $form).loading('error');
                            }
                            $('.order-submit', $form).loading('finish');
                            dialogs.welcomeDialogZiggy.open();
                        });
                    });
                }
            });

        }
    }


    /* Validator config */

    $.validator.addMethod("noFilesQueued", function (value, element) {
        var dz = Dropzone.forElement($(element).closest('.dropzone')[0]);
        return (!dz.getUploadingFiles().length && !dz.getQueuedFiles().length);
    }, "Wait till all files are loaded");

    $.validator.addMethod("noErrorOccured", function (value, element) {
        var dz = Dropzone.forElement($(element).closest('.dropzone')[0]);
        return (!dz.getRejectedFiles().length || dz.getAcceptedFiles().length);
    }, 'An error occurred.');

    $.validator.addMethod("filesUploaded", function (value, element) {
        var dz = Dropzone.forElement($(element).closest('.dropzone')[0]);
        return (dz.getAcceptedFiles().length);
    }, 'Please, upload videos from your events to turn them into beautiful movie');

    $.validator.addMethod("emailWithDomainExtensionForNataliaLedenova", function (value, element) {
        return /\.[A-z]+$/i.test(value);
    }, $.validator.messages.email);


    /* Welcome dialog */

    $(function () {
        var _welcomeForm = $('[data-remodal-id="welcome-ziggy"]');

        $('.edit-button-ziggy', _welcomeForm).on('click', function (e) {
            e.preventDefault();
            $('.edit-button-ziggy', _welcomeForm).addClass('hidden');
            $('.email-field', _welcomeForm).prop('disabled', false).focus();
            return;
        });
    });


    /* Init */

    $(function () {

        if ($('body').data('loggedIn')) {
            $(window).trigger('loggedIn', $('body').data('userMail'));
        } else {
            $(window).trigger('loggedOut');
        }

        $('.orderform, .orderform-ziggy').initOrderform();

    });


    /*
     *
     * ************ API ************
     *
     * api.method(data[, callback])
     *   data - object / jQuery object
     *          OR primitive, if only one value can be sent
     *   callback - function([err[, data]])
     *     err - null | array of errors
     *     data - server response
     *
     * *****************************
     */

    window.api = (function () {

        /* Add token to request object */
        var _addToken = function (object, method) {
            if (method === 'post') {
                var _token = $('html head meta[name="csrf_token"]').prop('content');
                if (object instanceof Array) {
                    object.push({
                        name: 'csrf_token',
                        value: _token
                    });
                    console.info('Token %s added in request', _token);
                } else {
                    object.csrf_token = _token;
                    console.info('Token %s added in request', object.csrf_token);
                }
            } else {
                console.info('No add token on get method');
            }

            return object;
        };

        /* Log response */
        var _log = function (text, response) {
            var rect = 'background:#333; color:#ccc;' +
                'font-size:11px; display:inline-block;' +
                '-moz-padding-start:5px; -moz-padding-end:5px;' +
                'margin-right:3px; border-radius:2px;';
            console.log(
                '%c%s%c%s%c%O',
                rect + 'color:#cf6;',
                ' ' + text + ' ',
                rect + 'font-size:10px;',
                ' New token: ' + response.responseJSON.csrf_token + ' ',
                'background:initial; color:initial;',
                response.responseJSON
            );
        }

        /* Log response errors */
        var _logErrors = function (errors) {
            var rect = 'background:#900; color:#eee;' +
                'font-size:11px; display:inline-block;' +
                '-moz-padding-start:5px; -moz-padding-end:5px;' +
                'margin-right:3px; border-radius:2px;';
            errors.forEach(function (error) {
                console.warn('%c%s', rect, ' ' + error + ' ');
            });
        }

        /*
         * Eah, sometimes there is empty 'errors', although 'success' !== true,
         * sometimes 'errors' is array, sometimes object / string...
         */
        var _pushError = function (errorsArray, response) {
            var error = response.responseJSON.errors
            if (!error || (error instanceof Array && !error.length)) {
                errorsArray.push('Api error (without description)');
            } else if (typeof error === 'string') {
                errorsArray.push(error);
            } else if (error instanceof Array) {
                $.merge(errorsArray, error);
            } else if (error instanceof Object) {
                for (var e in error) {
                    if (error.hasOwnProperty(e)) {
                        errorsArray.push(e + ': ' + error[e]);
                    }
                }
            }
        }

        /* Make request */
        var _apiRequest = function (url, method, data, preCallback, callback) {
            if (data instanceof $) {
                data = data.serializeArray();
            }
            $.ajax({
                url: url,
                dataType: 'json',
                method: method,
                data: _addToken(data, method),
                complete: function (response) {

                    var errors = [];
                    if (response.status === 401) {
                        errors.push('Relogin needed');
                        dialogs.loginDialogZiggy.open();
                    }
                    if (!response.responseJSON) {
                        response.responseJSON = {success: false, data: null}
                        errors.push('Bad api response');
                    } else {
                        if (method === 'post') {
                            if (!response.responseJSON.csrf_token) {
                                errors.push('Didn\'t get csrf_token');
                            } else {
                                $('html head meta[name="csrf_token"]')
                                    .prop('content', response.responseJSON.csrf_token);
                            }
                        }

                        if (!response.responseJSON.success) {
                            _pushError(errors, response);
                        }
                    }

                    if (!errors.length) {
                        errors = null
                    } else {
                        if (errors) {
                            _logErrors(errors);
                        }
                    }

                    if (typeof preCallback === 'function') {
                        preCallback(errors, response);
                    }
                    if (typeof callback === 'function') {
                        callback(errors, response.responseJSON.data);
                    }

                }
            });
        }


        return {
            checkLogin: function (){
                _apiRequest('/auth/checklogin','post', true, function (err, response) {
                    if (response.responseJSON.data.status == 1)
                    {  
                        if (response.responseJSON.data.email)
                        {
                            $('#email').val(response.responseJSON.data.email);
                            $('#email').attr('disabled','disabled');

                        }
                        $('#tel').val(response.responseJSON.data.phone);
                        $('.intro-top-menu-item .signin-button').hide();
                        $('.intro-top-menu-item .orders-button').show();
                        $('.intro-top-menu-item .signout-button').show();
                        $('.signin-button').loading('finish');
                        $('#login-pass').val('');
                        $('.social-links').hide();
                        if ($('.remodal-active').attr('data-remodal-id') == 'login-ziggy')
                        {
                            dialogs.loginDialogZiggy.close();
                        }
                        $('body')
                            .data('loggedIn', true)
                            .data('userMail', response.responseJSON.email);
                        _log('Logged in', response);
                    }
                }, function(){});
            },
            /* Login */
            authLogin: function (data, callback) {
                _apiRequest('/auth/login', 'post', data, function (err, response) {
                        if (err) {
                            return;
                        }
                        $('body')
                            .data('loggedIn', true)
                            .data('userMail', response.responseJSON.email);
                        _log('Logged in', response);
                    },
                    callback);
            },

            /* Change mail */
            authUpdate: function (email, callback) {
                _apiRequest('/auth/update', 'post', {
                        email: email
                    }, function (err, response) {
                        if (err) {
                            return;
                        }
                        _log('Changed mail', response);
                    },
                    callback);
            },

            /* Restore email */
            authRestore: function (form, callback) {
                _apiRequest('/auth/forgot', 'post', form, function (err, response) {
                        if (err) {
                            return;
                        }
                        _log('Requested mail restore', response);
                    },
                    callback);
            },

            /* Check if email exists */
            checkIsEmailExists: function (email, callback) {
                _apiRequest('/auth/check-is-email-exists', 'post', {
                        email: email
                    }, function (err, response) {
                        if (err) {
                            return;
                        }
                        _log('Checked if user exists', response);
                    },
                    callback);
            },
            /* Check if email exists */
            createTempOrder: function (orderData, callback) {
                _apiRequest('/order/create-temp', 'post',
                        orderData,
                        function (err, response) {
                            if (err) {
                                return;
                            }
                            _log('Temp order created', response);
                },
                callback);
            },
            /* Create user */
            authCreate: function (email, callback) {
                _apiRequest('/auth/create', 'post', {
                        email: email
                    }, function (err, response) {
                        if (err) {
                            return;
                        }
                        $('body').data('loggedIn', true);
                        _log('User created', response);
                    },
                    callback);
            },

            /* Create order */
            orderCreate: function (orderData, callback) {
                _apiRequest('/order/create', 'post',
                    orderData,
                    function (err, response) {
                        if (err) {
                            return;
                        }
                        _log('Order created', response);
                    },
                    callback);
            },

            /* Edit order */
            orderUpdate: function (orderData, callback) {
                _apiRequest('/order/update', 'post',
                    orderData,
                    function (err, response) {
                        if (err) {
                            return;
                        }
                        _log('Order updated', response);
                    },
                    callback);
            },

            /* Cancel order */
            orderCancel: function (orderId, callback) {
                _apiRequest('/order/cancel', 'post',
                    {order_id: orderId},
                    function (err, response) {
                        if (err) {
                            return;
                        }
                        _log('Order updated', response);
                    },
                    callback);
            },

            /* Logout */
            authLogout: function (areYouShure, callback) {
                _apiRequest('/auth/logout', 'post', {
                        logout: areYouShure
                    }, function (err, response) {
                        if (err) {
                            return;
                        }
                        $('body')
                            .data('loggedIn', false)
                            .data('userMail', '');
                        _log('Logged out', response);
                    },
                    callback);
            },

            /* Get order data by ID */
            getOrdersList: function (nothing, callback) {
                _apiRequest('/orders/get/', 'get', {}, function (err, response) {
                        if (err) {
                            return;
                        }
                        _log('Got orders list', response);
                    },
                    callback);
            },

            /* Get chat messages by order ID */
            getChatMessages: function (orderId, callback) {
                _apiRequest('/messages/get/' + orderId, 'get', {}, function (err, response) {
                        if (err) {
                            return;
                        }
                        _log('Got chat messsages', response);
                    },
                    callback);
            },

            /* Mark chat message as read */
            markChatMessageAsRead: function (messagesIds, callback) {
                _apiRequest('/message/mark-as-read/', 'post',
                    {
                        messages: messagesIds
                    },
                    function (err, response) {
                        if (err) {
                            return;
                        }
                        _log('Marked chat message as read', response);
                    },
                    callback);
            },

            /* Get order data by ID */
            getOrderInfo: function (orderId, callback) {
                _apiRequest('/order/get/' + orderId, 'get', {}, function (err, response) {
                        if (err) {
                            return;
                        }
                        _log('Got order info', response);
                    },
                    callback);
            },

            /* Delete Uploaded file by ID */
            fileDelete: function (fileId, callback) {
                _apiRequest('/file/delete', 'post', {
                        file_id: fileId
                    }, function (err, response) {
                        if (err) {
                            return;
                        }
                        _log('Deleted file', response);
                    },
                    callback);
            },

        };
    }());


    /* Handlebars date helper */

    Handlebars.registerHelper('formatDate', function (datetime, format, message) {
        if (datetime === false) {
            message = typeof message === 'string' ? message : '-';
            return message;
        }

        if (moment) {
            return moment(datetime).format({
                short: 'MMM D',
                long: 'MMMM DD, YYYY \\at HH:mm'
            }[format]);
        }
        else {
            return datetime;
        }
    });


    /* Handlebars currency helper */

    Handlebars.registerHelper('formatCurrency', function (sum, zeroFormat) {
        sum = parseFloat(sum);
        if (sum === 0) {
            switch (zeroFormat) {
                case 'free':
                    return 'Free';
                default:
                    return sum.toFixed(2);
            }
        }
        else if (!isNaN(sum)) {
            return '$' + sum.toFixed(2);
        }
        else {
            return '--';
        }
    });


    /* Handlebars plurarize helper */

    Handlebars.registerHelper('pluralize', function (number, single, plural) {
        return number === 1 ? single : plural;
    });


    /* Handlebars length (minutes) helper */

    Handlebars.registerHelper('lengthMin', function (mins) {
        var secs = 60 * parseFloat(mins);
        var length = '';

        if (secs >= 60) {
            length += Math.floor(secs / 60) + ' min';
            if (secs % 60) {
                length += ', '
            }
        }
        if (secs % 60) {
            length += secs % 60 + ' sec';
        }
        if (length.length) {
            return length;
        }
        else {
            return '--';
        }
    });

    Handlebars.registerHelper('ifEqual', function (a, b, opts) {
        if (a === b) {
            return opts.fn(this);
        }
        else {
            return opts.inverse(this);
        }
    });

    Handlebars.registerHelper('eachSorted', function (array, key, opts) {
        key = key.trim();
        var reverse = key[0] === '-';
        if (reverse) {
            key = key.substr(1)
        }
        var e, output, _i, _len;
        array = array.sort(function (a, b) {
            a = a[key];
            b = b[key];
            if (a > b === reverse) {
                return 1;
            }
            if (a === b) {
                return 0;
            }
            if (a < b === reverse) {
                return -1;
            }
        });
        output = '';
        for (_i = 0, _len = array.length; _i < _len; _i++) {
            e = array[_i];
            output += opts.fn(e);
        }
        return output;
    });


    /*
     * jQuery throttle / debounce - v1.1 - 3/7/2010
     * http://benalman.com/projects/jquery-throttle-debounce-plugin/
     */
    (function (b, c) {
        var $ = b.jQuery || b.Cowboy || (b.Cowboy = {}), a;
        $.throttle = a = function (e, f, j, i) {
            var h, d = 0;
            if (typeof f !== "boolean") {
                i = j;
                j = f;
                f = c
            }
            function g() {
                var o = this, m = +new Date() - d, n = arguments;

                function l() {
                    d = +new Date();
                    j.apply(o, n)
                }

                function k() {
                    h = c
                }

                if (i && !h) {
                    l()
                }
                h && clearTimeout(h);
                if (i === c && m > e) {
                    l()
                } else {
                    if (f !== true) {
                        h = setTimeout(i ? k : l, i === c ? e - m : e)
                    }
                }
            }

            if ($.guid) {
                g.guid = j.guid = j.guid || $.guid++
            }
            return g
        };
        $.debounce = function (d, e, f) {
            return f === c ? a(d, e, false) : a(d, f, e !== false)
        }
    })(this);



}(jQuery));
